var _path, _path2, _rect, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9716)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9716)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#05AB41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53152 10.5598C3.12552 10.2971 3.12552 9.70307 3.53152 9.44037L13.6377 2.90109C13.8581 2.75849 14.1416 2.75849 14.362 2.90109L24.4682 9.44037C24.8742 9.70307 24.8742 10.2971 24.4682 10.5598L14.362 17.0991C14.1416 17.2417 13.8581 17.2417 13.6377 17.0991L3.53152 10.5598Z",
    fill: "#FDD216"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 14.6666C16.5775 14.6666 18.6668 12.5772 18.6668 9.99992C18.6668 7.42259 16.5775 5.33325 14.0002 5.33325C11.4228 5.33325 9.3335 7.42259 9.3335 9.99992C9.3335 12.5772 11.4228 14.6666 14.0002 14.6666Z",
    fill: "#053087"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_9716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 10,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 14.6666C16.5775 14.6666 18.6668 12.5772 18.6668 9.99992C18.6668 7.42259 16.5775 5.33325 14.0002 5.33325C11.4228 5.33325 9.3335 7.42259 9.3335 9.99992C9.3335 12.5772 11.4228 14.6666 14.0002 14.6666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_9716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.77987 8.78008C9.51257 8.18676 11.8769 8.74883 14.084 9.33757C16.291 9.92631 18.5929 11.1603 19.179 11.8841",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9716"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryBr);
export default __webpack_public_path__ + "static/media/Country=BR.d9293e90af80b8a62aa58aebfe5fbde8.svg";
export { ForwardRef as ReactComponent };